import { AvatarImageCore, AvatarImageCoreProps } from './AvatarImageCore';

const AvatarImage = AvatarImageCore;
export type AvatarImageProps = AvatarImageCoreProps;

export default AvatarImage;
